import type { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import type { Party } from "@/lib/party.api";
import { PartyRoleBadges, PartyStatusBadge } from "../party/components/PartyBadges";

export const partyColumns: ColumnDef<Party, any>[] = [
  {
    accessorKey: "fullName",
    header: "Nom",
    cell: ({ row }) => (
      <>
        <Link
          to={`/parties/${row.original.id}`}
          className="text-[12px] font-medium text-brand-gold-dark hover:underline"
        >
          {row.original.fullName}
        </Link>
        {row.original.code && (
          <span className="ml-1.5 text-[10.5px] text-muted-foreground">{row.original.code}</span>
        )}
      </>
    ),
  },
  {
    id: "contact",
    header: "Contact",
    cell: ({ row }) => (
      <span className="text-[12px] text-muted-foreground">
        {row.original.phone ?? row.original.email ?? "-"}
      </span>
    ),
  },
  {
    id: "role",
    header: "Rôle",
    cell: ({ row }) => <PartyRoleBadges party={row.original} />,
  },
  {
    accessorKey: "active",
    header: "Statut",
    cell: ({ row }) => <PartyStatusBadge active={row.original.active} />,
  },
];
